import { render, staticRenderFns } from "./AppealDetail.vue?vue&type=template&id=06e8dde4&scoped=true&"
import script from "./AppealDetail.vue?vue&type=script&lang=js&"
export * from "./AppealDetail.vue?vue&type=script&lang=js&"
import style0 from "./AppealDetail.vue?vue&type=style&index=0&id=06e8dde4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e8dde4",
  null
  
)

export default component.exports